import React from "react";
import { Card, CardBody, FormGroup, Input, Label } from "reactstrap";

interface PincodeCheckboxListProps {
  pincodes: any[];
  selected: any[];
  onChange: (selected: any[]) => void;
  checkAllEnabled?: boolean;
}

const PincodeCheckboxList: React.FC<PincodeCheckboxListProps> = ({ pincodes, selected, onChange, checkAllEnabled }) => {
  // Convert all selected IDs to string for comparison
  const selectedStr = selected.map((id) => String(id));
  const allIds = pincodes.map((p) => String(p.id));
  const allChecked = allIds.length > 0 && allIds.every((id) => selectedStr.includes(id));
  const handleCheckboxChange = (id: any) => {
    const idStr = String(id);
    let newSelected;
    if (selectedStr.includes(idStr)) {
      newSelected = selectedStr.filter((s) => s !== idStr);
    } else {
      newSelected = [...selectedStr, idStr];
    }
    onChange(newSelected);
  };
  const handleCheckAll = () => {
    if (allChecked) {
      // Uncheck all
      onChange(selectedStr.filter((id) => !allIds.includes(id)));
    } else {
      // Check all
      const merged = Array.from(new Set([...selectedStr, ...allIds]));
      onChange(merged);
    }
  };
  return (
    <Card style={{ maxHeight: 250, overflowY: "auto" }}>
      <CardBody>
        {checkAllEnabled && pincodes.length > 0 && (
          <FormGroup check className="mb-2">
            <Input
              type="checkbox"
              checked={allChecked}
              onChange={handleCheckAll}
              id="pincode-checkbox-all"
            />
            <Label for="pincode-checkbox-all" check style={{ marginLeft: 8, fontWeight: 600 }}>
              Check All ({selectedStr?.length})
            </Label>
          </FormGroup>
        )}
        {pincodes.length === 0 && <div>No pincodes found.</div>}
        {pincodes.map((p) => (
          <FormGroup check key={p.id} className="mb-2">
            <Input
              type="checkbox"
              checked={selectedStr.includes(String(p.id))}
              onChange={() => handleCheckboxChange(p.id)}
              id={`pincode-checkbox-${p.id}`}
            />
            <Label for={`pincode-checkbox-${p.id}`} check style={{ marginLeft: 8 }}>
              {`${p.name} - ${p.region} - ${p.district} - ${p.state}`}
            </Label>
          </FormGroup>
        ))}
      </CardBody>
    </Card>
  );
};

export default PincodeCheckboxList;
